function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState, useMemo, useEffect, useCallback } from "react";
import SortDown from "@pixel/assets/icons/SortDown";
import SortUp from "@pixel/assets/icons/SortUp";
import Sort from "@pixel/assets/icons/Sort";
import Box from "../Box";
import Button from "../Button";
import MenuItem from "../MenuItem";
import Menu from "../Menu";
import { styled } from "../styles";
import ButtonGroup from "../ButtonGroup";
import { flushSync } from 'react-dom';

// we use this instead of an enum because we want to be able to use the values as types

/**
 * SortOrderProps
 *
 */

/**
 * AppliedSortOrderProps
 * sort that is currently active
 */

/**
 * SortChangedProps
 * the props that get passed back to the onSort Event
 */

/* props to be passed to ListSort component */

const toggleDirection = direction => direction === "asc" ? "desc" : "asc";
const appliedSortOrderHasAnotherDirection = appliedSortOrder => !(appliedSortOrder.sortOrder.directions.length === 1 && appliedSortOrder.sortOrder.directions[0] === appliedSortOrder.direction);
const IconSpan = styled("span")(_ref => {
  let {
    theme
  } = _ref;
  return {
    position: "absolute",
    right: "12px",
    top: "6px",
    fontSize: "20px",
    paddingLeft: "10px"
  };
});
const ListSort = _ref2 => {
  let {
    label = "Sort By",
    labelSortBy = "Sort By",
    labelAsc = "Ascending",
    labelDesc = "Descending",
    sortOrders,
    appliedSortOrder,
    buttonProps,
    menuProps,
    onSort,
    color = 'info',
    compact = false
  } = _ref2;
  const [newAppliedSortOrder, setNewAppliedSortOrder] = useState(appliedSortOrder);
  const [hoverAppliedSortOrder, setHoverappliedSortOrder] = useState(newAppliedSortOrder);
  const [hovered, setHovered] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = useState(Boolean(anchorEl));
  const toggleButton = useCallback(event => {
    setAnchorEl(event.currentTarget);
  }, []);
  useEffect(() => {
    if (newAppliedSortOrder !== appliedSortOrder) {
      setNewAppliedSortOrder(appliedSortOrder);
    }
  }, [appliedSortOrder]);
  useEffect(() => {
    setOpen(Boolean(anchorEl));
  }, [anchorEl]);

  //CONST FUNCTIONS
  /* toggle the direction of the sort icon */

  const findSelectedSortOrderById = id => sortOrders.find(sortOrder => sortOrder.id === id);
  const handleActiveClick = useCallback(() => {
    const hasAnotherSortableDirection = appliedSortOrderHasAnotherDirection(newAppliedSortOrder);
    if (!hasAnotherSortableDirection) return;
    const newDirection = toggleDirection(newAppliedSortOrder.direction);
    const newSortOrder = {
      sortOrder: newAppliedSortOrder.sortOrder,
      direction: newDirection
    };
    setNewAppliedSortOrder(newSortOrder);
    setHoverappliedSortOrder(newSortOrder);
    onSort({
      newSortOrder: newSortOrder
    });
  }, [newAppliedSortOrder, setNewAppliedSortOrder, setHoverappliedSortOrder, setHovered, onSort]);
  const handleApplySortOrder = useCallback(sortOrderId => {
    const selectedSortOrder = findSelectedSortOrderById(sortOrderId);
    let newDirection = null;
    const isSelectedSameAsApplied = selectedSortOrder.id === newAppliedSortOrder.sortOrder.id;
    if (isSelectedSameAsApplied) {
      const hasAnotherSortableDirection = appliedSortOrderHasAnotherDirection(newAppliedSortOrder);
      if (!hasAnotherSortableDirection) {
        return; // can't change direction so do nothing
      } else {
        newDirection = toggleDirection(newAppliedSortOrder.direction); //change direction
      }
    } else {
      newDirection = selectedSortOrder.directions[0]; //set to default direction (first in list)
    }
    const newSortOrder = {
      sortOrder: selectedSortOrder,
      direction: newDirection
    };
    setNewAppliedSortOrder(newSortOrder);
    setHovered(false);
    window.setTimeout(() => {
      onSort({
        newSortOrder: newSortOrder
      });
    }, 50);
  }, [newAppliedSortOrder, setNewAppliedSortOrder, setHovered, onSort]);
  const handleCloseMenu = useCallback(() => {
    if (typeof flushSync === 'function') {
      flushSync(() => {
        setOpen(false);
        setAnchorEl(null);
        setHovered(false);
        setHoverappliedSortOrder(newAppliedSortOrder);
      });
    } else {
      setOpen(false);
      setAnchorEl(null);
      setHovered(false);
      setHoverappliedSortOrder(newAppliedSortOrder);
    }
  }, [setOpen, setAnchorEl, setHovered, setHoverappliedSortOrder, newAppliedSortOrder]);
  const handleMenuItemClick = useCallback(event => {
    handleCloseMenu(); //close right away
    const sortOrderId = event.currentTarget.getAttribute("value");
    handleApplySortOrder(sortOrderId);
  }, [handleCloseMenu, setOpen, handleApplySortOrder]);

  /* mouse enters the menu item */
  const handleMouseEnter = event => {
    const value = event.currentTarget.getAttribute("value");
    const selectedSortOrder = findSelectedSortOrderById(value);
    let newDirection;
    const isSelectedSameAsNewApplied = selectedSortOrder.id === newAppliedSortOrder.sortOrder.id;
    const isSelectedSameAsHoverApplied = selectedSortOrder.id === hoverAppliedSortOrder.sortOrder.id;
    const newAppliedSortOrderDoesNotHaveAltDirection = newAppliedSortOrder.sortOrder.directions.length === 1 && newAppliedSortOrder.sortOrder.directions[0] === newAppliedSortOrder.direction;
    const newAppliedSortOrderHasAltDirection = newAppliedSortOrder.sortOrder.directions.length === 2;
    const hoverAppliedSortOrderHasAltDirection = newAppliedSortOrder.sortOrder.directions.length === 2;
    if (isSelectedSameAsNewApplied && newAppliedSortOrderDoesNotHaveAltDirection) {
      return;
    }
    if (isSelectedSameAsHoverApplied && hoverAppliedSortOrderHasAltDirection) {
      newDirection = toggleDirection(hoverAppliedSortOrder.direction);
    } else if (isSelectedSameAsNewApplied && !isSelectedSameAsHoverApplied) {
      newDirection = toggleDirection(newAppliedSortOrder.direction);
    } else if (!isSelectedSameAsNewApplied && !isSelectedSameAsHoverApplied) {
      newDirection = selectedSortOrder.directions[0];
    } else {
      return;
    }
    const newSortOrder = {
      sortOrder: selectedSortOrder,
      direction: newDirection
    };
    setHoverappliedSortOrder(newSortOrder);
    setHovered(true);
  };

  /* mouse leaves the menu item */

  const handleFocusOut = () => {
    setHovered(false);
    setHoverappliedSortOrder(newAppliedSortOrder);
  };
  const LabelIcon = _ref3 => {
    let {
      id
    } = _ref3;
    const isHoverSortApplied = id === hoverAppliedSortOrder.sortOrder.id && hovered;
    const is_new_sort_applied = id === newAppliedSortOrder.sortOrder.id;
    const renderHoveredIcon = hoverAppliedSortOrder.direction === "desc" ? /*#__PURE__*/React.createElement(SortDown, {
      color: "disabled"
    }) : /*#__PURE__*/React.createElement(SortUp, {
      color: "disabled"
    });
    const renderNewIcon = newAppliedSortOrder.direction === "desc" ? /*#__PURE__*/React.createElement(SortDown, {
      color: "primary"
    }) : /*#__PURE__*/React.createElement(SortUp, {
      color: "primary"
    });
    if (isHoverSortApplied) {
      return /*#__PURE__*/React.createElement("span", null, renderHoveredIcon);
    }
    if (is_new_sort_applied) {
      return /*#__PURE__*/React.createElement("span", null, renderNewIcon);
    }
    return null;
  };
  let ariaLabel = newAppliedSortOrder.sortOrder.ariaLabel || newAppliedSortOrder.sortOrder.label;
  if (newAppliedSortOrder.direction === "asc" || newAppliedSortOrder.direction === "desc") {
    ariaLabel = "".concat(ariaLabel, ", ").concat(newAppliedSortOrder.direction === "desc" ? labelDesc : labelAsc);
  }
  const renderCompact = useMemo(() => {
    return /*#__PURE__*/React.createElement(Button, _extends({
      id: "sort-button",
      "aria-controls": open ? "listSort" : undefined,
      "aria-haspopup": "true",
      "aria-expanded": open ? "true" : undefined,
      variant: "outlined",
      disableElevation: true,
      "aria-label": ariaLabel,
      onClick: toggleButton,
      color: color,
      sx: {
        minWidth: 24,
        pl: 1,
        pr: 1
      }
    }, buttonProps), /*#__PURE__*/React.createElement(Sort, null));
  }, [compact, toggleButton, ariaLabel, color, buttonProps]);
  const renderRegualarButtonGroup = useMemo(() => {
    return /*#__PURE__*/React.createElement(ButtonGroup, {
      variant: "outlined",
      "aria-label": "split button"
    }, /*#__PURE__*/React.createElement(Button, _extends({
      id: "sort-button",
      "aria-controls": open ? "listSort" : undefined,
      "aria-haspopup": "true",
      "aria-expanded": open ? "true" : undefined,
      variant: "outlined",
      disableElevation: true,
      "aria-label": ariaLabel,
      onClick: toggleButton,
      startIcon: /*#__PURE__*/React.createElement(Sort, null),
      color: color
    }, buttonProps), /*#__PURE__*/React.createElement("span", {
      style: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: "nowrap"
      }
    }, "".concat(labelSortBy, " : ").concat(newAppliedSortOrder.sortOrder.label))), /*#__PURE__*/React.createElement(Button, {
      variant: "outlined",
      disableElevation: true,
      onClick: handleActiveClick,
      color: color,
      sx: {
        paddingLeft: 0.5,
        paddingRight: 0.5
      }
    }, newAppliedSortOrder.direction === "asc" ? /*#__PURE__*/React.createElement(SortUp, null) : /*#__PURE__*/React.createElement(SortDown, null)));
  }, [compact, open, ariaLabel, toggleButton, labelSortBy, newAppliedSortOrder, handleActiveClick, color, buttonProps]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, compact ? renderCompact : renderRegualarButtonGroup, /*#__PURE__*/React.createElement(Menu, _extends({
    id: "sort-menu",
    MenuListProps: {
      sx: {
        width: anchorEl && anchorEl.offsetWidth + 50
      }
    },
    anchorEl: anchorEl,
    "data-testid": "list_sort_menu",
    open: open,
    onClose: handleCloseMenu
  }, menuProps), sortOrders.map(sortOrder => {
    const isHoverSortApplied = sortOrder.id === hoverAppliedSortOrder.sortOrder.id;
    let newAriaLabel = "";
    if (isHoverSortApplied) {
      newAriaLabel = hoverAppliedSortOrder.direction === "desc" ? labelDesc : labelAsc;
    }
    const isSelected = sortOrder.id === newAppliedSortOrder.sortOrder.id;
    const isBold = hovered && isHoverSortApplied || isSelected;
    return /*#__PURE__*/React.createElement(MenuItem, {
      id: sortOrder.id,
      "aria-label": newAriaLabel,
      key: sortOrder.id,
      value: sortOrder.id,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleFocusOut,
      onKeyUp: handleMouseEnter,
      onBlur: handleFocusOut,
      onClick: handleMenuItemClick,
      "data-testid": sortOrder.id,
      selected: isSelected,
      sx: {
        display: "flex",
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    }, /*#__PURE__*/React.createElement(Box, {
      sx: {
        fontWeight: isBold ? "600" : "300",
        flex: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingRight: "20px"
      }
    }, sortOrder.label), /*#__PURE__*/React.createElement(IconSpan, null, /*#__PURE__*/React.createElement(LabelIcon, {
      id: sortOrder.id
    })));
  })));
};
export default ListSort;